import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './MentionsLegalesPage.module.css';

const MentionsLegalesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Mentions légales</title>
        <meta property="og:title" content="Mentions légales" />
        <meta name="twitter:title" content="Mentions légales" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* Header */}
      <section className={styles.header}>
        <h1 className={styles.title}>Mentions légales</h1>
      </section>

      {/* Content */}
      <section className={styles.content}>
        <div className={styles.container}>
          <h2 className={styles.subtitle}>En vigueur au 07/01/2025</h2>

          <p className={styles.text}>
            Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004
            pour la Confiance en l'économie numérique, il est porté à la
            connaissance des utilisateurs et visiteurs, ci-après l'
            &laquo;&nbsp;Utilisateur&nbsp;&raquo;, du site{' '}
            <a href="https://www.brands2buyers.io/" className={styles.link}>
              https://www.brands2buyers.io/
            </a>{' '}
            , ci-après le &laquo;&nbsp;Site&nbsp;&raquo;, les présentes
            mentions légales.
          </p>

          <p className={styles.text}>
            La connexion et la navigation sur le Site par l'Utilisateur implique
            acceptation intégrale et sans réserve des présentes mentions légales.
          </p>

          <p className={styles.text}>
            Ces dernières sont accessibles sur le Site à la rubrique
            &laquo;&nbsp;Mentions légales&nbsp;&raquo;.
          </p>

          <h3 className={styles.sectionTitle}>EDITION DU SITE</h3>

          <p className={styles.text}>
            L'édition et la direction de la publication du Site est assurée par
            Madame Laetitia Lamari, domiciliée 18 Rue Arago 94370 Sucy en Brie,
            dont le numéro de téléphone est 0619374187, et l'adresse e-mail est{' '}
            <a href="mailto:laetitia@lecafedelecommerce.fr" className={styles.link}>
              laetitia@lecafedelecommerce.fr
            </a>
            . ci-après l'&laquo;&nbsp;Editeur&nbsp;&raquo;.
          </p>

          <h3 className={styles.sectionTitle}>HEBERGEUR</h3>

          <p className={styles.text}>
            L'hébergeur du Site est la société Webflow, Inc, dont le siège
            social est situé au siège social : 398 11th Street 94103 San
            Francisco.
          </p>

          <h3 className={styles.sectionTitle}>ACCES AU SITE</h3>

          <p className={styles.text}>
            Le Site est normalement accessible, à tout moment, à l'Utilisateur.
            Toutefois, l'Editeur pourra, à tout moment, suspendre, limiter ou
            interrompre le Site afin de procéder, notamment, à des mises à jour
            ou des modifications de son contenu. L'Editeur ne pourra en aucun
            cas être tenu responsable des conséquences éventuelles de cette
            indisponibilité sur les activités de l'Utilisateur.
          </p>

          <h3 className={styles.sectionTitle}>COLLECTE DES DONNEES</h3>

          <p className={styles.text}>
            Le Site assure à l'Utilisateur une collecte et un traitement des
            données personnelles dans le respect de la vie privée conformément à
            la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux
            fichiers aux libertés et dans le respect de la règlementation
            applicable en matière de traitement des données à caractère
            personnel conformément au règlement (UE) 2016/679 du Parlement
            européen et du Conseil du 27 avril 2016 (ci-après, ensemble, la
            &laquo;&nbsp;Règlementation applicable en matière de protection des
            Données à caractère personnel&nbsp;&raquo;).
          </p>

          <p className={styles.text}>
            En vertu de la Règlementation applicable en matière de protection
            des Données à caractère personnel, l'Utilisateur dispose d'un droit
            d'accès, de rectification, de suppression et d'opposition de ses
            données personnelles. L'Utilisateur peut exercer ce droit :
          </p>

          <p className={styles.text}>
            - par mail à l'adresse email{' '}
            <a href="mailto:hello@brands2buyers.io" className={styles.link}>
              hello@brands2buyers.io
            </a>
          </p>

          <p className={styles.text}>
            Toute utilisation, reproduction, diffusion, commercialisation,
            modification de toute ou partie du Site, sans autorisation expresse
            de l'Editeur est prohibée et pourra entraîner des actions et
            poursuites judiciaires telles que prévues par la règlementation en
            vigueur.
          </p>

          <p className={styles.text}>
            Pour plus d'informations, se reporter aux CGU du site{' '}
            <a href="https://www.brands2buyers.io/" className={styles.link}>
              https://www.brands2buyers.io/
            </a>{' '}
            accessibles depuis la rubrique &laquo;&nbsp;CGU&nbsp;&raquo;.
          </p>
        </div>
      </section>
    </>
  );
};

export default MentionsLegalesPage;
